/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PandaWebhookData } from '../models/PandaWebhookData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PandaService {

    /**
     * @param requestBody 
     * @returns any Success
     * @throws ApiError
     */
    public static postApiPandaWebhook(
requestBody?: Array<PandaWebhookData>,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Panda/webhook',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

}
